import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { useTheme } from '../../contexts/ThemeContext'
import AuthLayout from '../../components/auth/AuthLayout'
import FormInput from '../../components/auth/FormInput'
import FormButton from '../../components/auth/FormButton'
import ToastNotification from '../../components/ToastNotification'

export default function LoginPage() {
  const { theme } = useTheme()
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  })
  const [showToast, setShowToast] = useState(false)
  const [toastMessage, setToastMessage] = useState('')
  const [toastType, setToastType] = useState<'success' | 'error'>('success')
  const [loading, setLoading] = useState(false)
  const { login } = useAuth()
  const navigate = useNavigate()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)

    try {
      const result = await login(formData.email, formData.password)
      if (result.success) {
        setToastMessage('Đăng nhập thành công!')
        setToastType('success')
        setShowToast(true)
        setTimeout(() => {
          navigate('/')
        }, 1500)
      } else {
        setToastMessage(result.error || 'Đăng nhập thất bại. Vui lòng thử lại!')
        setToastType('error')
        setShowToast(true)
      }
    } catch (error) {
      setToastMessage('Đăng nhập thất bại. Vui lòng thử lại!')
      setToastType('error')
      setShowToast(true)
    } finally {
      setLoading(false)
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  return (
    <>
      <ToastNotification
        message={toastMessage}
        type={toastType}
        isVisible={showToast}
        onClose={() => setShowToast(false)}
      />
      
      <AuthLayout title="Đăng Nhập">
        <form onSubmit={handleSubmit} className="space-y-6">
          <FormInput
            label="Email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="your@email.com"
            required
          />

          <FormInput
            label="Mật khẩu"
            name="password"
            type="password"
            value={formData.password}
            onChange={handleChange}
            placeholder="••••••••"
            required
          />

          <div className="flex items-center justify-between">
            <label className={`flex items-center gap-2 ${theme === 'dark' ? 'text-gray-300' : 'text-gray-600'}`}>
              <input type="checkbox" className={`w-4 h-4 text-gold-600 rounded focus:ring-gold-500 ${theme === 'dark' ? 'border-gold-500' : 'border-gold-400'}`} />
              <span className="text-sm">Ghi nhớ đăng nhập</span>
            </label>
            <Link to="/forgot-password" className={`text-sm transition ${theme === 'dark' ? 'text-gold-400 hover:text-gold-300' : 'text-gold-500 hover:text-gold-600'}`}>
              Quên mật khẩu?
            </Link>
          </div>

          <FormButton disabled={loading}>
            {loading ? 'Đang xử lý...' : 'Đăng Nhập'}
          </FormButton>

          <div className={`text-center ${theme === 'dark' ? 'text-gray-300' : 'text-gray-600'}`}>
            <p>
              Chưa có tài khoản?{' '}
              <Link to="/register" className={`font-semibold transition ${theme === 'dark' ? 'text-gold-400 hover:text-gold-300' : 'text-gold-500 hover:text-gold-600'}`}>
                Đăng ký ngay
              </Link>
            </p>
          </div>
        </form>
      </AuthLayout>
    </>
  )
}

